<template>
  <div class="popup_content">
    <div class="back" style="position: relative;">
      <img src="@/assets/topback.png" alt="" width="100%" style="display: block;">
      <div style="position: absolute;text-align: center;top: 20%;left: 0;right: 0;">
        <img src="@/assets/logo.png" alt="" width="28%" style="z-index:999;">
      </div>
    </div>
    <div style="text-align:center;background-color: #d1c0ab;">
      <div style="padding-top:10%;margin-top:0;margin-bottom:5px;color: #5e4d39;letter-spacing: 2px;font-size: 24px;">
        校外人员来访申请信息填报</div>
      <img src="@/assets/line.png" alt="" width="60%" style="padding: 20px 0;">
      <div style="margin:0 auto;padding-bottom:5px;text-align:justify;width:90%">
        <div id="tip">
          <p>
            ○ 校外人员进入南开大学办事须提前通过本系统提交申请材料并由对接部门（和您直接联系的部门）审批后生效。
          </p>
          <p>
            ○ 请您务必先和对接部门沟通后获取"邀请码"并按下面的要求如实填写相应信息提交。如未进行有效沟通，可能会耽误审批时间并影响您的行程。
          </p>
          <p>
            ○校外人员只能提交当日或次日的入校申请 ，来校时间和离校时间需在同一天。建议您提前一天提交申请，等待南开大学审批。
          </p>
          <p>
            ○校外人员出入校门，应无发热、干咳、乏力、咽痛、嗅(味)觉减退、鼻塞、流涕、结膜炎、肌痛和腹泻等症状。
          </p>
          <p>
            ○ 请您持本人身份证刷卡入校。
          </p>
          <p style="margin-bottom: 5%;">
            ○ 如您在进入南开大学时遇到困难，请和对接部门联系人直接沟通。
          </p>
        </div>
      </div>
      <img src="@/assets/break.png" alt="" width="100%">
    </div>
    <div style="background-color: #e8e0d5;">
      <CellGroup inset class="roster_list"
        style="width:95%;padding-top:20px;margin:0 auto;max-width:1920px;">
        <Cell class="form_line_cell">
          <div class="custom_sites_cell">
            <div class="van-cell__title van-field__label van-field__label--required">
              <label id="van-field-1-label" for="van-field-1-input" data-allow-mismatch="attribute">是否有邀请码</label>
            </div>
            <RadioGroup v-model="haveCode">
              <Radio name="1" icon-size="14px">是</Radio>
              <Cell v-if="haveCode == 1" class="default_sites_cell form_line_cell">
                <Field required v-model="inviteCode" label="邀请码" placeholder="请填写邀请码" :rules="[{ required: true, message: '请填写邀请码' }]"/>
              </Cell>
              <Radio name="2" icon-size="14px" style="margin-top: 10px;">否</Radio>
              <Cell v-if="haveCode == 2" class="default_sites_cell form_line_cell">
                <Field required v-model="deptname" is-link readonly label="对接部门" placeholder="请选择对接部门"
                  @click="fnOpenDeptPopup" :rules="[{ required: true, message: '请选择对接部门' }]"/>
                <Popup v-model:show="showDeptPicker" round position="bottom">
                  <Search v-model="searchDept" style="display: flex;" placeholder="请输入部门进行检索" @search="fnSearchDept" @clear="fnClearSearch">
                  </Search>
                  <Picker :columns="deptTypeOptions" @cancel="showDeptPicker = false" @confirm="fnDeptConfirm" :model-value="getDepartment">

                    <!-- <template #toolbar>
                      <button style="color:#969799;border:0;" @click="showDeptPicker = false">取消</button>
                    <div class="van-picker__title van-ellipsis">请选择对接部门</div>
                    <button v-if="deptTypeOptions.length > 0" style='color:#1989fa;border:0;' @click="fnDeptConfirm()">确认</button>
                  </template> -->
                  </Picker>
                </Popup>
              </Cell>
            </RadioGroup>
          </div>
        </Cell>
        <Cell class="default_sites_cell form_line_cell">
          <Field required v-model="contactPeople" label="联系人" placeholder="请填写联系老师的姓名" :rules="[{ required: true, message: '请填写联系老师的姓名' }]"/>
        </Cell>
        <Cell class="default_sites_cell form_line_cell">
          <Field required v-model="username" label="申请人" placeholder="请填写姓名" :rules="[{ required: true, message: '请填写申请人姓名' }]"/>
        </Cell>
        <Cell class="default_sites_cell form_line_cell">
          <Field required v-model="idCardType" is-link readonly label="身份证类别" placeholder="请选择身份证类别"
            @click="showIdCardTypePicker = true" :rules="[{ required: true, message: '请选择身份证类别' }]"/>
          <!-- 默认身份证 -->
          <Popup v-model:show="showIdCardTypePicker" round position="bottom">
            <Picker :columns="idCardTypeOptions" @cancel="showIdCardTypePicker = false"
              @confirm="fnIdCardTypeConfirm" :model-value="idCardTypeCode"/>
          </Popup>
        </Cell>
        <Cell class="default_sites_cell form_line_cell">
          <Field required v-model="idCard" label="证件号" placeholder="请填写证件号" :rules="[{ required: true, message: '请填写证件号' }]"/>
        </Cell>
        <Cell class="default_sites_cell form_line_cell">
          <Field required v-model="mobile" label="联系方式(手机号)" placeholder="请填写手机号" :rules="[{ required: true, message: '请填写手机号' }]"/>
        </Cell>
        <Cell class="form_line_cell default_sites_cell ">
          <Field required v-model="startTime" is-link readonly name="datePicker" label="预计来校时间" placeholder="请选择预计来校时间"
            @click="fnShowStartTimePicker" :rules="[{ required: true, message: '请选择预计来校时间' }]"/>
          <Popup v-model:show="showStartTimePicker" position="bottom">
            <PickerGroup title="请选择预计来校时间" :tabs="['选择日期', '选择时间']"
            v-model:active-tab="DatePickerActive"
             @confirm="fnStartTimeConfirm"
              @cancel="showStartTimePicker = false">
              <DatePicker v-model="applyStartDate" />
              <TimePicker v-model="applyStartTime" />
            </PickerGroup>
          </Popup>
        </Cell>
        <Cell class="form_line_cell default_sites_cell ">
          <Field required v-model="endTime" is-link readonly name="datePicker" label="预计离校时间" placeholder="请选择预计离校时间"
            @click="fnShowEndTimePicker" :rules="[{ required: true, message: '请选择预计离校时间' }]"/>
          <Popup v-model:show="showEndTimePicker" position="bottom">
            <PickerGroup title="请选择预计离校时间" :tabs="['选择日期', '选择时间']" 
            v-model:active-tab="DatePickerActive" 
            @confirm="fnEndTimeConfirm"
              @cancel="showEndTimePicker = false">
              <DatePicker v-model="applyEndDate" />
              <TimePicker v-model="applyEndTime" />
            </PickerGroup>
          </Popup>
        </Cell>
        <Cell class="form_line_cell">
          <div class="custom_sites_cell">
            <div class="van-cell__title van-field__label van-field__label--required">
              <label id="van-field-1-label" for="van-field-1-input" data-allow-mismatch="attribute">是否在学校就餐</label>
            </div>
            <RadioGroup v-model="dining" direction="horizontal">
              <Radio name="1" icon-size="14px">是</Radio>
              <Radio name="2" icon-size="14px">否</Radio>
            </RadioGroup>
          </div>
        </Cell>
        <Cell class="default_sites_cell form_line_cell">
          <Field required v-model="reason" is-link readonly label="来校原因" placeholder="请选择来校原因"
            @click="showReasonPicker = true" :rules="[{ required: true, message: '请选择来校原因' }]"/>
          <Popup v-model:show="showReasonPicker" round position="bottom">
            <Picker :columns="reasonOptions" @cancel="showReasonPicker = false" @confirm="fnReasonConfirm" :model-value="reasonCode"/>
          </Popup>
        </Cell>
        <Cell inset class="default_sites_cell form_line_cell">
          <Field required v-model="remark" rows="2" autosize label="来校具体事由" type="textarea" maxlength="200"
            placeholder="不超过200字" show-word-limit :rules="[{ required: true, message: '来校具体事由' }]"/>
        </Cell>
        <Cell class="form_line_cell">
          <div class="custom_sites_cell">
            <div class="van-cell__title van-field__label van-field__label--required">
              <label id="van-field-1-label" for="van-field-1-input" data-allow-mismatch="attribute">是否驾车</label>
            </div>
            <RadioGroup v-model="drive" direction="horizontal">
              <Radio name="1" icon-size="14px">是</Radio>
              <Cell v-if="drive == 1" class="default_sites_cell form_line_cell">
                <Field required v-model="carinfo" label="车牌号" placeholder="请填写车牌号" :rules="[{ required: true, message: '请填写车牌号' }]"/>
              </Cell>
              <Radio name="2" icon-size="14px">否</Radio>
            </RadioGroup>
          </div>
        </Cell>
        <Cell class="form_line_cell">
          <div class="custom_sites_cell">
            <div class="van-cell__title van-field__label van-field__label--required">
              <label id="van-field-1-label" for="van-field-1-input"
                data-allow-mismatch="attribute">本人承诺出入校门，无发热、干咳、乏力、咽痛、嗅(味)觉减退、鼻塞、流涕、结膜炎、肌痛和腹泻等症状，入校遵守南开大学各项管理规定。</label>
            </div>
          </div>
          <Checkbox icon-size="14px" v-model="promise">我承诺</Checkbox>
        </Cell>
      </CellGroup>
      <div class="popup_submit_btn">
        <Button style="width: 80%;" @click="fnSubmit">提交申请</Button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  Popup, Cell, CellGroup, Button,
  RadioGroup, Radio, Field, PickerGroup,
  DatePicker, TimePicker, Picker, Checkbox, Search, showDialog, showToast, showConfirmDialog,showSuccessToast,showFailToast
} from 'vant';
import fnGetData from '@/utils/request'; // 接口请求方法
import { onMounted,ref, watch } from 'vue';
import router from '@/router/index'
import {useRoute} from 'vue-router';
const route = useRoute();
const getDepartment = ref([]); //部门编码
// #region 新增入校申请
const getLocalData = ref({}); // 获取localStorage中的数据
// 初始化数据
const originDate = ref([new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), (new Date().getDate()+1).toString()]);//初始化日期
const originTime = ref(['08', '00']); //初始化时间
const haveCode = ref(null); // 是否有邀请码
const inviteCode = ref(null); // 邀请码
const deptname = ref(null); // 对接部门
const contactPeople = ref(null); // 联系人
const username = ref(null); // 申请人
const idCard = ref(null); // 证件号类型label
const idCardType = ref(null); // 身份证件类别
const idCardTypeCode = ref([]); // 证件号类型code
const mobile = ref(null); // 手机号
const startTime = ref(null); //预计来校时间
const applyStartDate = ref(null); // 选择来校日期
const applyStartTime = ref(null); // 选择来校时间
const endTime = ref(null); //预计离校时间
const applyEndDate = ref(null); // 选择离校日期
const applyEndTime = ref(null); // 选择离校时间
const dining = ref(null); // 是否在学校就餐
const reason = ref(null); // 来校原因label
const reasonCode = ref([]);// 来校原因code
const remark = ref(null); // 来校具体事由
const drive = ref(null); // 是否驾车
const carinfo = ref(null); // 车牌号
const promise = ref(null); // 承诺

watch([haveCode, inviteCode, deptname, getDepartment, contactPeople, username, idCard, idCardType, idCardTypeCode, mobile, startTime, applyStartDate, applyStartTime, endTime, applyEndDate, applyEndTime, dining, reason, reasonCode, remark, drive, carinfo, originDate, originTime], 
  ([haveCodeVal, inviteCodeVal, deptnameVal, getDepartmentVal, contactPeopleVal, usernameVal, idCardVal,idCardTypeVal, idCardTypeCodeVal, mobileVal, startTimeVal, applyStartDateVal, applyStartTimeVal, endTimeVal, applyEndDateVal, applyEndTimeVal, diningVal, reasonVal, reasonCodeVal, remarkVal, driveVal, carinfoVal, originDateVal, originTimeVal]) => {
  localStorage.setItem("applydata", JSON.stringify({
    haveCode: haveCodeVal,
    inviteCode: haveCodeVal == 1 ? inviteCodeVal : null,
    deptname: haveCodeVal == 2 ? deptnameVal : null,
    getDepartment: haveCodeVal == 2 ? getDepartmentVal : [],
    contactPeople: contactPeopleVal,
    username: usernameVal,
    idCard: idCardVal,
    idCardType: idCardTypeVal,
    idCardTypeCode: idCardTypeCodeVal,
    mobile: mobileVal,
    startTime: startTimeVal,
    applyStartDate: applyStartDateVal,
    applyStartTime: applyStartTimeVal,
    endTime: endTimeVal,
    applyEndDate: applyEndDateVal,
    applyEndTime: applyEndTimeVal,
    dining: diningVal,
    reason: reasonVal,
    reasonCode: reasonCodeVal,
    remark: remarkVal,
    drive: driveVal,
    carinfo: driveVal == 1 ? carinfoVal : null
  }));
});
console.log(1111,localStorage.getItem('applydata'))



// 新增入校申请-对接部门picker
const showDeptPicker = ref(false); //是否显示对接部门列表picker
const deptTypeOptions = ref([]); // 当前显示部门
let originDeptOptions = []; // 默认全部部门
// const deptTypeOptions = ref([]);
// 获取部门列表
const fnGetDepartment = () => {
  fnGetData('/outschool/index/getDepartment', {
  }, 30000, function (dataobj) {
    // loading.value = false;
    // dataobj.data.data = {"1":"宣传部","2":"化学院"}
    
    if (dataobj.data.status === 0) {
      deptTypeOptions.value = [];
      for(let i in dataobj.data.data){
        deptTypeOptions.value.push({text:dataobj.data.data[i],value:i})
        if(getDepartment.value[0] == i){
          haveCode.value = '2';
          deptname.value = dataobj.data.data[i]
        }
      }
      originDeptOptions = deptTypeOptions.value = deptTypeOptions.value.sort((a, b) => {return a.text.localeCompare(b.text, 'zh-CN')})


      // if(dataobj.data.data && dataobj.data.data.length > 0)
      // {
      //   originDeptOptions = deptTypeOptions.value = dataobj.data.data;
      //   for (let i = 0; i < dataobj.data.data.length; i++) {
      //     if(getDepartment.value[0] == dataobj.data.data[i].value){
      //       haveCode.value = '2';
      //       deptname.value = dataobj.data.data[i].text
      //     }
      //   }
      // }
    }
    else {
      showFailToast(dataobj.data.msg)
    }
  })
}
const searchDept = ref(null); // 检索部门字段
// 检索部门
const fnSearchDept = () => {
  deptTypeOptions.value = originDeptOptions.filter(item => item.text.includes(searchDept.value));
}
// 清除检索部门
const fnClearSearch = () => {
  deptTypeOptions.value = originDeptOptions;
}
// 打开选择部门popup
const fnOpenDeptPopup = () => {
    showDeptPicker.value = true;
    searchDept.value = null;
    deptTypeOptions.value = originDeptOptions;
}
// 选中部门
const fnDeptConfirm = ({ selectedValues,selectedOptions }) => {
  if(selectedOptions && selectedOptions[0] && selectedOptions[0].value)
  {
    deptname.value = `${selectedOptions[0].text}`
    getDepartment.value = selectedValues
    showDeptPicker.value = false
  }
  else
  {
    showFailToast("未选中任何部门，若无需选择请点击取消按钮")
  }
};

// 新增入校申请-身份证件类别picker
const showIdCardTypePicker = ref(false); //是否显示身份证件类别列表picker
const idCardTypeOptions = [
  { text: '居民身份证', value: 1 },
  { text: '其他证件号', value: 2 }
];
const fnIdCardTypeConfirm = ({ selectedValues,selectedOptions }) => {
  idCardType.value = `${selectedOptions[0].text}`
  idCardTypeCode.value = selectedValues
  showIdCardTypePicker.value = false
};

const DatePickerActive = ref(0); // DateGroup初始tab为日期tab
// 新增入校申请-预计来校时间picker
const showStartTimePicker = ref(false); //选择预计来校时间popup
const fnShowStartTimePicker = () => {
  showStartTimePicker.value = true;
  DatePickerActive.value = 0;
  if(startTime.value && startTime.value.split(' ').length  == 2)
  {
    applyStartDate.value = startTime.value.split(' ')[0].split('-');
    applyStartTime.value = startTime.value.split(' ')[1].split(':');
  }
  else{
    applyStartDate.value = originDate.value;
    applyStartTime.value = originTime.value;
  }
}
const fnStartTimeConfirm = () => {
  startTime.value = `${applyStartDate.value.join('-')} ${applyStartTime.value.join(':')}`;
  showStartTimePicker.value = false;
}
// 新增入校申请-预计离校时间picker
const showEndTimePicker = ref(false); //选择预计离校时间popup
const fnShowEndTimePicker = () => {
  showEndTimePicker.value = true;
  DatePickerActive.value = 0;
  if(endTime.value && endTime.value.split(' ').length  == 2)
  {
    applyEndDate.value = endTime.value.split(' ')[0].split('-');
    applyEndTime.value = endTime.value.split(' ')[1].split(':');
  }
  else{
    applyEndDate.value = originDate.value;
    applyEndTime.value = originTime.value;
  }
}
const fnEndTimeConfirm = () => {
  endTime.value = `${applyEndDate.value.join('-')} ${applyEndTime.value.join(':')}`;
  showEndTimePicker.value = false;
}
// 新增入校申请-来校原因picker
const showReasonPicker = ref(false); //是否显示来校原因列表picker
const reasonOptions = [
  { text: '交流合作', value: 1 },
  { text: '招聘宣讲', value: 2 },
  { text: '送货维护', value: 3 },
  { text: '其他', value: 4 }
];
const fnReasonConfirm = ({ selectedValues,selectedOptions }) => {
  reason.value = `${selectedOptions[0].text}`
  reasonCode.value = selectedValues
  showReasonPicker.value = false
};
// #endregion 新增入校申请

// 提交申请
const fnSubmit = () => {
  if (haveCode.value == null) {
    showFailToast('请选择是否有邀请码');
  }
  else if (haveCode.value == 1 && inviteCode.value == null) {
    showFailToast('请填写邀请码')
  }
  else if (haveCode.value == 2 && deptname.value == null) {
    showFailToast('请选择对接部门')
  }
  else if (contactPeople.value == null) {
    showFailToast('请填写联系老师姓名')
  }
  else if (username.value == null) {
    showFailToast('请填写申请人姓名')
  }
  else if (idCardType.value == null) {
    showFailToast('请选择身份证类别')
  }
  else if (idCard.value == null) {
    showFailToast('请填写证件号')
  }
 else if (mobile.value == null) {
    showFailToast('请填写手机号')
 }
  else if (startTime.value == null) {
    showFailToast('请选择预计来校时间')
  }
  else if (dining.value == null) {
    showFailToast('请选择是否在学校就餐')
  }
  else if (reason.value == null) {
    showFailToast('请选择来校原因')
  }
  else if (remark.value == null) {
    showFailToast('请填写来校具体事由')
  }
  else if (drive.value == null) {
    showFailToast('请选择是否驾车')
  }
  else if (drive.value == 1 && carinfo.value == null) {
    showFailToast('请填写车牌号')
  }
  else if (promise.value == null) {
    showFailToast('请勾选承诺')
  }
  else {
    showConfirmDialog({
      title: '确认提交申请',
      message: '确认提交申请？',
    })
      .then(() => {
        // on confirm
        // 调用接口
        fnGetData('/outschool/index/addSchoolApply', {
          ifhavecode: haveCode.value,
          code: inviteCode.value,
          deptcode: getDepartment.value[0],
          contacts_username: contactPeople.value,
          username: username.value,
          zjhtype: idCardTypeCode.value[0],
          zjh: idCard.value,
          mobile: mobile.value,
          onshelves_time: startTime.value,
          offshelves_time: endTime.value,
          if_eat: dining.value,
          come_reason: reasonCode.value[0],
          come_for: remark.value,
          if_car: drive.value,
          carinfo: carinfo.value,
          promise: promise.value,
        }, 30000, function (dataobj) {
          if (dataobj.data.status === 0) {
            showSuccessToast('提交成功');
            // 返回首页
            router.push({ name:'Home'})
          }
          else {
            showFailToast(dataobj.data.msg)
          }
        })
      })
      .catch(() => {
        // on cancel
      });
  }
}
onMounted(()=>{
  // 调用接口
  fnGetDepartment()
  const storedData = localStorage.getItem("applydata"); // 获取localStorage中的数据
  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      // 恢复表单数据
      haveCode.value = parsedData.haveCode;
      inviteCode.value = parsedData.inviteCode;
      deptname.value =  (route.params.departcode && route.params.departcode != 0) ? null : parsedData.deptname;
      getDepartment.value = (route.params.departcode && route.params.departcode != 0) ? [route.params.departcode] : parsedData.getDepartment;
      contactPeople.value = parsedData.contactPeople;
      username.value = parsedData.username;
      idCard.value = parsedData.idCard;
      idCardType.value = parsedData.idCardType;
      idCardTypeCode.value = parsedData.idCardTypeCode;
      mobile.value = parsedData.mobile;
      startTime.value = parsedData.startTime;
      applyStartDate.value = parsedData.applyStartDate;
      applyStartTime.value = parsedData.applyStartTime;
      endTime.value = parsedData.endTime;
      applyEndDate.value = parsedData.applyEndDate;
      applyEndTime.value = parsedData.applyEndTime;
      
      // originDate.value = parsedData.originDate ? parsedData.originDate : [new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), (new Date().getDate()+1).toString()]
      // originTime.value = parsedData.originTime ? parsedData.originTime : ['08', '00'];
      dining.value = parsedData.dining;
      reason.value = parsedData.reason;
      reasonCode.value = parsedData.reasonCode;
      remark.value = parsedData.remark;
      drive.value = parsedData.drive;
      carinfo.value = parsedData.carinfo;
    } catch (e) {
      console.error('解析localStorage数据失败:', e);
    }
  }
})
</script>

<style scoped>
.notice_tip {
  /* margin: var(--van-cell-group-inset-padding); */
  margin-bottom: 10px;
  text-align: center;
  background-color: #d1c0ab;
  padding: var(--van-cell-vertical-padding) var(--van-cell-horizontal-padding);
  font-size: 14px;
}

#tip p {
  /*margin-bottom: 5%;*/
  font-weight: 550;
  letter-spacing: 2px;
  line-height: 1.8;
  color: #333;
  font-size: 14px;
  margin: 0 0 10px;
}

#tip {
  padding-bottom: 20px;
}

.van-cell-group,.van-cell {
  background: inherit;
}
.popup_submit_btn{
  text-align:center;
  padding:20px 0;
  background-color: #e8e0d5;
}
.popup_submit_btn > .van-button{
  background-color: #8e4f06;
  border-color: #8e4f06;
  color: #e8e0d5;
  opacity: 1;
  font-size: 18px;
}
.van-cell.van-field:active{
  background: #e8e0d5;
}
textarea::placeholder{
  color: #000;
}
</style>